import { isNativeApp } from "@/lib/native-platform";

/**
 * Native commerce kill-switch.
 *
 * Google Play / App Store builds must never expose Stripe. For the first
 * internal-test builds we also ship WITHOUT active in-app purchases: the flag
 * VITE_NATIVE_COMMERCE_ENABLED must be explicitly set to "true" to enable
 * Apple IAP / Play Billing. Web/PWA is unaffected.
 */
export function isNativeCommerceEnabled(): boolean {
  return import.meta.env.VITE_NATIVE_COMMERCE_ENABLED === "true";
}

/** True when a purchase/checkout surface may be rendered at all. */
export function arePaymentsAvailable(): boolean {
  if (!isNativeApp()) return true;
  return isNativeCommerceEnabled();
}
